"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'table.controls.export': 'Esporta',
    'table.controls.columns': 'Colonne',
};
